import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=6b64a8a6&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=6b64a8a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64a8a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b64a8a6')) {
      api.createRecord('6b64a8a6', component.options)
    } else {
      api.reload('6b64a8a6', component.options)
    }
    module.hot.accept("./addGoods.vue?vue&type=template&id=6b64a8a6&scoped=true", function () {
      api.rerender('6b64a8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditProduct/addGoods.vue"
export default component.exports